import { render, staticRenderFns } from "./SendMessageTargetWaiterRow.vue?vue&type=template&id=ba6feaba&scoped=true&lang=pug"
import script from "./SendMessageTargetWaiterRow.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetWaiterRow.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTargetWaiterRow.vue?vue&type=style&index=0&id=ba6feaba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6feaba",
  null
  
)

export default component.exports